import { createCrudActions } from '../utils/crudGenerator';

const formatAccounts = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchAccounts,
    create: createAccount,
    update: updateAccount,
    delete: deleteAccounts
} = createCrudActions('ACCOUNT', "Cuenta", formatAccounts);